import { API } from "../store"
import update from "immutability-helper"

export const companiesReducerDefaultState = {
  editCompanyDialogOpen: false,
  createCompanyDialogOpen: false,
  editCompany: {},
  activeCompany: null,
  accessLevel: "",
  companyShootFields: null,
  bookingDialogOpen: false,
  bookingUser: {},
  bookingPosition: "",
  suggestPositionDialogOpen: false,
}

export default (state = companiesReducerDefaultState, action) => {
  switch (action.type) {
    case "COMPANIES::TOGGLE_EDIT_DIALOG":
      return {
        ...state,
        editCompanyDialogOpen: action.editCompanyDialogOpen,
        editCompany:
          action.editCompany === undefined
            ? state.editCompany
            : action.editCompany,
      }
    case "COMPANIES::SET_COMPANY_SHOOT_FIELDS":
      return {
        ...state,
        companyShootFields: action.companyShootFields,
      }

    case "COMPANIES::TOGGLE_CREATE_DIALOG":
      return {
        ...state,
        createCompanyDialogOpen: action.createCompanyDialogOpen,
      }
    case "COMPANIES::TOGGLE_BOOKING_DIALOG":
      let updates = {
        bookingDialogOpen: {
          $set: action.bookingDialogOpen,
        },
        bookingUser: {
          $set: action.bookingUser,
        },
      }
      if (action.position) {
        updates.bookingPosition = {
          $set: action.position,
        }
      }
      return update(state, updates)
    case "COMPANIES::TOGGLE_SUGGEST_POSITION_DIALOG":
      let updated = {
        suggestPositionDialogOpen: {
          $set: !state.suggestPositionDialogOpen,
        },
      }
      return update(state, updated)
    case "COMPANIES::COMPANY_UPDATED":
      return {
        ...state,
        editCompany: {
          ...state.editCompany,
          ...action.company,
        },
      }
    case "COMPANIES::SWITCH_ACTIVE_COMPANY":
      API.use(req => {
        let query = req._query
        let existingQueryString
        query.forEach((q, i) => {
          if (q.indexOf("company_id=") > -1 || q.indexOf("company_id") > -1) {
            existingQueryString = i
          }
        })

        if (existingQueryString > -1) {
          if (action.companyId) {
            query = query.splice(
              existingQueryString,
              1,
              `company_id=${action.companyId}`
            )
          } else {
            query = query.splice(existingQueryString, 1)
          }
        } else {
          return req.query({
            company_id: action.companyId,
          })
        }
        return req
      })
      return {
        ...state,
        activeCompany: action.companyId,
        accessLevel: action.accessLevel === "" ? 2 : action.accessLevel,
      }
    default:
      return state
  }
}
